import { types } from './actions'

const initialState = {
  project: undefined
}

const project = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case types.SET_PROJECT: {
      state = { ...state, project: payload }
      break
    }

    default:
      break
  }
  return state
}

export default project